import { createNavigation } from "next-intl/navigation";
import { localePrefix, locales, pathnames, defaultLocale } from "./config";

export const { Link, redirect, usePathname, useRouter } = createNavigation({
	locales,
	pathnames,
	localePrefix,
	defaultLocale,
});
